<ng-select class="custom-multi-select aip-theme-bg" [closeOnSelect]="false" [multiple]="true"  [appendTo]="appendTo"  (change)="filterSelect()"
  [items]="items" [bindValue]="bindValue" [bindLabel]="bindLabel" [(ngModel)]="selectedValues"
  [groupBy]="groupBy" [selectableGroup]="selectableGroup" [selectableGroupAsModel]="selectableGroupAsModel" [disabled]="disabled">
  <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
    <div class="ng-value" *ngFor="let item of items | slice:0:1">
      <span>
        <span class="ng-value-label" [title]="item[bindLabel]" [style.maxWidth.px]="(items.length > 1 || !selectedOptionWidth) ? selectedOptionWidth : selectedOptionWidth + 36">{{item[bindLabel]}}</span>
        <span class="ng-value-icon right" (click)="clear(item);" aria-hidden="true">×</span>
      </span>
    </div>
    <div class="ng-value" *ngIf="items.length > 1">
      <span class="ng-value-label" [title]="'+ ' + (items.length - 1) + ' ...'">+ {{items.length - 1}} ...</span>
    </div>
  </ng-template>
</ng-select>
